import { TeamColor } from '../types';

export interface TeamColorConfig {
  color: TeamColor;
  name: string;
  colorCode: string;
  darkColorCode: string;
  lightColorCode: string;
}

export const TEAM_COLORS: Record<TeamColor, TeamColorConfig> = {
  [TeamColor.RED]: {
    color: TeamColor.RED,
    name: '赤',
    colorCode: '#E53935',
    darkColorCode: '#B71C1C',
    lightColorCode: '#FFCDD2'
  },
  [TeamColor.BLUE]: {
    color: TeamColor.BLUE,
    name: '青',
    colorCode: '#1E88E5',
    darkColorCode: '#0D47A1',
    lightColorCode: '#BBDEFB'
  },
  [TeamColor.GREEN]: {
    color: TeamColor.GREEN,
    name: '緑',
    colorCode: '#43A047',
    darkColorCode: '#1B5E20',
    lightColorCode: '#C8E6C9'
  },
  [TeamColor.YELLOW]: {
    color: TeamColor.YELLOW,
    name: '黄',
    colorCode: '#FFB300',
    darkColorCode: '#F57C00',
    lightColorCode: '#FFE0B2'
  },
  [TeamColor.PURPLE]: {
    color: TeamColor.PURPLE,
    name: '紫',
    colorCode: '#8E24AA',
    darkColorCode: '#4A148C',
    lightColorCode: '#E1BEE7'
  },
  [TeamColor.ORANGE]: {
    color: TeamColor.ORANGE,
    name: '橙',
    colorCode: '#FB8C00',
    darkColorCode: '#E65100',
    lightColorCode: '#FFD4B2'
  }
};

export const getTeamColorConfig = (color: TeamColor): TeamColorConfig => {
  return TEAM_COLORS[color];
};

export const getAllTeamColors = (): TeamColorConfig[] => {
  return Object.values(TEAM_COLORS);
};